export default {
  sm: `
  부가통신 서비스의 기반이 무너지면, 전반적인 
  경제 상황과 사회 활동이 마비될 수 있습니다.
  백업, 재해 복구(DR) 등 데이터 유실을 대비한 
  설계로 만일의 피해를 최소화하고, 빠른 복구가 
  가능하도록 대응합니다. 데이터센터 외부에서 
  발생한 재난 ∙ 재해에도 견고하고 안전하게 
  데이터를 지킵니다.
  `,
  md: `
  부가통신 서비스의 기반이 무너지면, 전반적인
  경제 상황과 사회 활동이 마비될 수 있습니다.
  백업, 재해 복구(DR) 등 데이터 유실을 대비한
  설계로 만일의 피해를 최소화하고, 빠른 복구가
  가능하도록 대응합니다. 데이터센터 외부에서 발생한 
  재난 ∙ 재해에도 견고하고 안전하게 데이터를 지킵니다.
  `,
  lg: `
  부가통신 서비스의 기반이 무너지면, 전반적인 경제 상황과 사회 활동이
  마비될 수 있습니다. 백업, 재해 복구(DR) 등 데이터 유실을 대비한 설계로 만일의
  피해를 최소화하고, 빠른 복구가 가능하도록 대응합니다. 데이터센터 외부에서 발생한
  재난 ∙ 재해에도 견고하고 안전하게 데이터를 지킵니다.
  `,
  xxl: `
  부가통신 서비스의 기반이 무너지면, 전반적인 경제 상황과 사회 활동이 마비될 수 있습니다.
  백업, 재해 복구(DR) 등 데이터 유실을 대비한 설계로 만일의 피해를 최소화하고, 빠른 복구가 가능하도록 
  대응합니다. 데이터센터 외부에서 발생한 재난 ∙ 재해에도 견고하고 안전하게 데이터를 지킵니다.
  `,
};  